import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Primary } from "@cinch-labs/design-system";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import React from "react";
import WBACLogo from "../assets/logo-full.webuyanycar.svg";
import styles from "./wbac.module.css";
/**
 * HOW HAS NO ONE USED TARGET=_BLANK BEFORE...
 * this works, and only expands the prop to add target.
 */ var CTALink = Primary;
export var TrackingEvents = {
    cta_click: {
        eventName: "We buy any car link",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "link",
                label: "We buy any car",
                action: "We buy any car link click"
            }
        }
    }
};
export var CTAUrl = "https://www.webuyanycar.com/?utm_source=cinch%5Fwebsite&utm_medium=button%5Fid%5F123&utm_campaign=sell%5Fyour%5Fcar";
var WeBuyAnyCar = function(param) {
    var body = param.body, cta = param.cta;
    var trackEvent = useAnalytics().trackEvent;
    var sendTrackEvent = function() {
        return trackEvent(TrackingEvents.cta_click);
    };
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "data-testid": "wbac",
        className: {
            inner: styles.innerWrapper
        },
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: body
            }),
            /*#__PURE__*/ _jsx(CTALink, {
                element: "a",
                href: CTAUrl,
                onClick: sendTrackEvent,
                classNames: {
                    button: styles.cta
                },
                target: "_blank",
                children: cta
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles["logoWrapper"],
                children: /*#__PURE__*/ _jsx(WBACLogo, {
                    className: styles["logo"]
                })
            })
        ]
    });
};
export default WeBuyAnyCar;
